import { Box } from "@mui/system";
import React, { ReactNode } from "react";
import { object } from "prop-types";

type AuthPageCarouselItem = {
  name: string;
  heading: string;
  description: ReactNode;
};

type AuthPageCarouselProps = {
  item: AuthPageCarouselItem;
};

export const AuthPageCarousel = (props: AuthPageCarouselProps) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignContent: "space-between",
          p: 3,
          m: 3,
          color: "white",
          maxWidth: "100%",
          height: `calc(100vh - 150px )`,
          borderRadius: 1,
        }}
      >
        <Box>
          <h2>{props.item.name}</h2>
        </Box>
        <Box>
          <h1>{props.item.heading}</h1>
          <p>{props.item.description}</p>
        </Box>
      </Box>
    </>
  );
};

AuthPageCarousel.propTypes = {
  item: object,
};
